import { generatePath } from 'react-router-dom';
import { RouteSegments } from '../routingClientAdmin.interface';
import { withOptionalDetailsId } from './withOptionalDetailsId';

export const generateClientSymbolsRoute = (nodeId: number, symbolName?: string) => {
  return generatePath(
    withOptionalDetailsId(`/${RouteSegments.Root.Config}/${RouteSegments.Pools.Symbols}`),
    { nodeId: String(nodeId), id: symbolName },
  );
};

export const generateClientSymbolsServerRoute = (serverId: string, symbolName?: string) => {
  return generatePath(
    withOptionalDetailsId(`/${RouteSegments.Root.Config}/${RouteSegments.Servers.Symbols}`),
    { serverId, id: symbolName },
  );
};
